<template>
	<div>
		<h3>Terminvereinbarung mit {{ applicantName ? applicantName : 'der Person' }}:</h3>
		<!--<JonInfo avatar-inline class="mt-1 mb-2">
			<template #message>
				Derselbe Termin kann gleichzeitig mehreren Personen vorgeschlagen werden, damit du nicht allzulange
				einen Termin nur für eine Person freihalten musst. Sobald eine Person diesen Termin ausgewählt hat, kann
				dieser Termin von anderen Personen nicht mehr ausgewählt werden.
			</template>
		</JonInfo>-->
		<JonInfo class="mt-1">
			<template #message>
				Bereits gebuchte oder von dir vorgeschlagene Termine siehst du
				<a href="#" @click.prevent="openAppointments">hier</a>.
			</template>
		</JonInfo>
		<b-row class="mt-3">
			<b-col md="5">
				<div class="sections">
					<section>
						<h3>Termingrund</h3>
						<MultiCheckboxSelect
							v-model="reasons"
							:options="reasonOptions"
							@input="reasonsChanged"
						/>
					</section>
				</div>
			</b-col>
			<b-col md="7">
				<div class="sections">
					<section v-if="typeEligible" class="mt-3 mt-md-0">
						<h3>Terminart</h3>
						<Select
							v-model="type"
							:options="typeOptions"
							undefined-text-option-text="--- Terminart ---"
							@input="typeChanged"
						/>
					</section>
				</div>
				<b-row v-if="reasons" class="mt-3">
					<b-col md="4">
						<div class="sections">
							<section>
								<h3>Dauer</h3>
								<SingleSelect
									v-model="duration"
									:characteristics="appointmentDurationCharacteristics"
									undefined-text-option-text="--- Dauer ---"
								/>
							</section>
						</div>
					</b-col>
					<b-col v-if="onlineActivityEligible" md="8">
						<div class="sections">
							<section>
								<h3>Onlinetätigkeit</h3>
								<b-form-checkbox v-model="onlineActivity">
									Ja (für Test, Assessment oder Probearbeit)
								</b-form-checkbox>
							</section>
						</div>
					</b-col>
				</b-row>
				<div
					v-if="type === types.phoneCall"
					class="mt-2 font-weight-bold color-primary"
				>
					Du erhältst die Telefonnummer {{ applicantName ? ('von ' + applicantName) : 'der Person' }}
					nach Termin-Bestätigung.
				</div>
				<div
					v-if="(onlineActivityEligible && onlineActivity) || (type === types.videoCall)"
					class="mt-2 font-weight-bold color-primary"
				>
					Link und Zugangsdaten können von dir an {{ applicantName ? applicantName : 'die Person' }} gesendet
					werden nach Rückbestätigung des Termins.
				</div>
				<div
					v-if="type === types.personalAtOrganisation"
					class="mt-2 font-weight-bold color-primary"
				>
					Adresse: {{ customer.street }} {{ customer.streetNumber }}, {{ customer.zip }} {{ customer.city }}
				</div>
			</b-col>
		</b-row>
		<div class="sections mt-4">
			<template v-if="type">
				<section v-if="type === types.personalNotAtOrganisation">
					<h3>
						Persönlicher Termin an einem anderen Ort - nicht an der Adresse deines Unternehmen/deiner
						Organisation:
					</h3>
					<AddressForm
						v-model="differentAddress"
						class="mt-2"
					/>
				</section>
				<section v-if="duration">
					<h3>{{ 'TeilnehmerInnen seitens ' + customer.companyName }}</h3>
					<div class="mt-2">
						<b-form-checkbox v-model="selfParticipation">Ich nehme teil</b-form-checkbox>
					</div>
					<div class="mt-2">
						<b-form-checkbox v-model="furtherParticipants" @change="furtherParticipantsChanged">
							Es gibt weitere Teilnehmer
						</b-form-checkbox>
						<div v-if="furtherParticipants" class="pl-3 mt-2">
							<Participant
								v-for="(participant, i) in furtherParticipantsList"
								:key="participant.id"
								:participant="participant"
								class="mt-1"
								:is-last="i === (furtherParticipantsList.length - 1)"
								@add="addFurtherParticipant"
								@change="changeFurtherParticipant(participant, $event)"
								@remove="removeFurtherParticipant(participant)"
							/>
						</div>
					</div>
				</section>
				<section v-if="participantsChosen && participantsValid">
					<h3>Terminmöglichkeiten</h3>
					<JonInfo v-if="!potentialDates || potentialDates.length === 0" class="mt-1">
						<template #message>
							Gib 3 bis 5 Termine zur Auswahl, dadurch wird die Abstimmung beschleunigt und vereinfacht.
						</template>
					</JonInfo>
					<FormGroup>
						<PotentialDates
							v-model="potentialDates"
							class="mb-2"
						/>
					</FormGroup>
				</section>
				<section
					v-if="potentialDatesValid && onlineActivityEligible && onlineActivity"
				>
					<h3>Die Onlinetätigkeit (für Test, Assessment oder Probearbeit):</h3>
					<FormGroup
						:state="onlineActivityExecutionValid"
						invalid-feedback="Bitte triff eine Auswahl"
					>
						<RadioGroup
							v-model="onlineActivityExecution"
							:options="onlineActivityExecutionOptions"
							stacked
						/>
					</FormGroup>
				</section>
				<section
					v-if="potentialDatesValid"
				>
					<h3>Gegenvorschläge</h3>
					<div class="d-flex align-items-center">
						<div class="flex-grow-1 mr-2">
							<div>
								Sollten deine Terminvorschläge nicht möglich sein, erhältst du eine Benachrichtigung.
							</div>
							<div>
								Solltest du Gegenvorschläge erhalten:
								<b>Wann können Termine spätestens starten?</b>
							</div>
						</div>
						<div>
							<FormGroup
								:state="counterProposalMaxTimeValid"
								invalid-feedback="Bitte wähle eine Uhrzeit aus"
								class="mt-2"
								feedback-beneath
							>
								<TimePicker
									v-model="counterProposalMaxTime"
									:focus-hour="14"
								/>
							</FormGroup>
						</div>
					</div>
				</section>
			</template>
		</div>
		<div class="d-flex align-items-center flex-column-reverse flex-md-row mt-5">
			<div v-if="withCancelButton" class="flex-grow-1 ml-0 ml-md-2 mt-2 mt-md-0">
				<a href="#" @click.prevent="$emit('cancel')">Abbrechen</a>
			</div>
			<div>
				<Button
					text="Terminvorschlag senden"
					icon="checkmark"
					:disabled="!dataValid || sendingRequest"
					:loading="sendingRequest"
					@click="sendRequest"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import InfoBox from "@/vue/common/InfoBox";
import * as AppointmentReason from "@/helper/communication/conversation/appointment/Reason";
import * as AppointmentType from "@/helper/communication/conversation/appointment/Type";
import * as AppointmentOnlineActivityExecution
	from "@/helper/communication/conversation/appointment/OnlineActivityExecution";
import Button from "@/vue/common/Button";
import MultiCheckboxSelect from "@/vue/common/form/MultiCheckboxSelect";
import AddressForm from "@/vue/geo/AddressForm"
import Select from "@/vue/common/form/Select";
import FormGroup from "@/vue/common/form/Group";
import {isDefined} from "@/helper/Value";
import {arrayIsNotEmpty} from "@/helper/Array";
import _ from "lodash";
import {mapActions, mapState} from "vuex";
import SingleSelect from "@/vue/characteristic/SingleSelect";
import RadioGroup from "@/vue/common/form/RadioGroup";
import Participant from "@/vue/communication/conversation/message/reply/Participant";
import {uuid} from "vue-uuid";
import TimePicker from "@/vue/common/form/TimePicker";
import Reply from "@/api/communication/conversation/message/Reply";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";
import {LIST_TYPE__CUSTOMER} from "@/store/communication/appointment";
import IconLink from "@/vue/common/IconLink";
import {APPOINTMENT_DURATION_LONG, hasTag} from "@/helper/characteristic/Tag";
import PotentialDates from "@/vue/communication/conversation/message/reply/PotentialDates.vue";
import {error} from "@/helper/Log";
import JonInfo from "@/vue/common/JonInfo.vue";

export default {

	components: {
		JonInfo,
		PotentialDates,
		IconLink,
		TimePicker,
		RadioGroup,
		InfoBox,
		Button,
		SingleSelect,
		MultiCheckboxSelect,
		AddressForm,
		FormGroup,
		Participant,
		Select,
	},

	props: {
		message: {
			type: Object,
			required: true,
		},
		applicantName: {
			type: String,
			required: false,
		},
		action: {
			type: String,
			required: true,
		},
		withCancelButton: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	data ()
	{
		let counterProposalMaxTime;

		if (this.message.customersLatestCounterProposalMaxTime)
		{
			const parts = this.message.customersLatestCounterProposalMaxTime.split(':');

			counterProposalMaxTime = {
				hour: parseInt(parts[0]),
				minute: parseInt(parts[1]),
			};
		}

		return {
			reasons: undefined,
			reasonOptions: [
				{value: AppointmentReason.INTERVIEW, text: AppointmentReason.getLabel(AppointmentReason.INTERVIEW)},
				{value: AppointmentReason.EXAMINATION, text: AppointmentReason.getLabel(AppointmentReason.EXAMINATION)},
				{value: AppointmentReason.ASSESSMENT_CENTER, text: AppointmentReason.getLabel(AppointmentReason.ASSESSMENT_CENTER)},
				{value: AppointmentReason.TRIAL, text: AppointmentReason.getLabel(AppointmentReason.TRIAL)},
			],
			type: undefined,
			types: {
				phoneCall: AppointmentType.PHONE_CALL,
				videoCall: AppointmentType.VIDEO_CALL,
				personalAtOrganisation: AppointmentType.PERSONAL_AT_ORGANISATION,
				personalNotAtOrganisation: AppointmentType.PERSONAL_NOT_AT_ORGANISATION,
			},
			onlineActivity: false,
			differentAddress: undefined,
			duration: undefined,
			selfParticipation: undefined,
			yesNoOptions: [
				{value: true, text: 'ja'},
				{value: false, text: 'nein'},
			],
			furtherParticipants: undefined,
			furtherParticipantsList: [],
			potentialDates: undefined,
			onlineActivityExecution: undefined,
			onlineActivityExecutionOptions: [
				{
					value: AppointmentOnlineActivityExecution.AT_APPOINTMENT,
					text: AppointmentOnlineActivityExecution.getLabel(AppointmentOnlineActivityExecution.AT_APPOINTMENT)
				},
				{
					value: AppointmentOnlineActivityExecution.UNTIL_APPOINTMENT,
					text: AppointmentOnlineActivityExecution.getLabel(AppointmentOnlineActivityExecution.UNTIL_APPOINTMENT)
				},
			],
			counterProposalMaxTime,
			sendingRequest: false
		};
	},

	computed: {
		...mapState('auth', ['customer']),
		...mapState('meta', ['meta']),
		reasonsValid ()
		{
			return isDefined(this.reasons) && arrayIsNotEmpty(this.reasons);
		},
		typeOptions ()
		{
			if (!this.typeEligible)
			{
				return [];
			}

			return [
				{
					value: AppointmentType.PHONE_CALL,
					text: 'Telefonat ohne Video'
				},
				{
					value: AppointmentType.VIDEO_CALL,
					text: 'Videoanruf'
				},
				{
					value: AppointmentType.PERSONAL_AT_ORGANISATION,
					text: 'Persönlicher Termin an der Adresse deiner Organisation'
				},
				{
					value: AppointmentType.PERSONAL_NOT_AT_ORGANISATION,
					text: 'Persönlicher Termin nicht an Adresse deiner Organisation'
				},
			];
		},
		typeEligible ()
		{
			return this.reasonsValid;
		},
		typeValid ()
		{
			return isDefined(this.type);
		},
		typeIsPersonalNotAtOrganisation ()
		{
			return this.type === this.types.personalNotAtOrganisation;
		},
		typeExtraDataValid ()
		{
			return !this.typeIsPersonalNotAtOrganisation || isDefined(this.differentAddress);
		},
		onlineActivityEligible ()
		{
			return _
				.filter(
					this.reasons,
					reason => _.includes(
						[
							AppointmentReason.EXAMINATION,
							AppointmentReason.ASSESSMENT_CENTER,
							AppointmentReason.TRIAL,
						],
						reason
					)
				)
				.length > 0;
		},
		appointmentDurationCharacteristics ()
		{
			const longDurationReasons = [
				AppointmentReason.ASSESSMENT_CENTER,
				AppointmentReason.TRIAL
			];

			const shortTypes = [
				this.types.phoneCall,
				this.types.videoCall
			];

			return _.filter(
				this.meta.appointmentDuration,
				characteristic =>
				{
					const hasLongDurationReason = _
						.intersection(longDurationReasons, this.reasons)
						.length > 0;

					const isShortType = _.includes(shortTypes, this.type);

					if (hasLongDurationReason && !isShortType)
					{
						return true;
					}

					return !hasTag(characteristic, APPOINTMENT_DURATION_LONG);
				}
			);
		},
		durationValid ()
		{
			return isDefined(this.duration);
		},
		participantsError ()
		{
			if (arrayIsNotEmpty(this.furtherParticipantsList))
			{
				const validFurtherParticipants = _.filter(
					this.furtherParticipantsList,
					p => p.valid
				);

				if (this.furtherParticipantsList.length !== validFurtherParticipants.length)
				{
					return 'Bitte prüfe die weiteren Teilnehmer';
				}
			}

			if (this.selfParticipation)
			{
				return null;
			}

			if (this.onlineActivity)
			{
				return null;
			}

			return 'Bitte wähle mindestens einen Teilnehmer/Teilnehmerin aus';
		},
		participantsChosen ()
		{
			return this.selfParticipation || arrayIsNotEmpty(this.furtherParticipantsList);
		},
		participantsValid ()
		{
			return !isDefined(this.participantsError);
		},
		potentialDatesValid ()
		{
			return isDefined(this.potentialDates);
		},
		onlineActivityExecutionEligible ()
		{
			return this.onlineActivityEligible && this.onlineActivity;
		},
		onlineActivityExecutionValid ()
		{
			return !this.onlineActivityExecutionEligible || isDefined(this.onlineActivityExecution);
		},
		counterProposalMaxTimeValid ()
		{
			return isDefined(this.counterProposalMaxTime);
		},
		dataValid ()
		{
			return this.reasonsValid
				&& this.typeValid
				&& this.typeExtraDataValid
				&& this.durationValid
				&& this.participantsValid
				&& this.potentialDatesValid
				&& this.onlineActivityExecutionValid
				&& this.counterProposalMaxTimeValid;
		},
		makeAppointmentData ()
		{
			let differentAddress = this.typeIsPersonalNotAtOrganisation
				? this.differentAddress
				: undefined;

			if (differentAddress)
			{
				const postalCode = _.first(differentAddress.postalCode.postalCodes);

				differentAddress = {
					postalCode: postalCode.postalCode,
					location: postalCode.characteristic.id,
					street: differentAddress.street,
					streetNumber: differentAddress.streetNumber,
					extraInfo: differentAddress.extraInfo,
				};
			}

			let furtherParticipants = undefined;

			if (this.furtherParticipants && this.furtherParticipantsList)
			{
				furtherParticipants = _.map(
					this.furtherParticipantsList,
					participant =>
					{
						return {
							salutation: participant.salutation,
							firstName: participant.firstName,
							lastName: participant.lastName,
							role: participant.role,
						};
					}
				);
			}

			return {
				reasons: this.reasons,
				type: this.type,
				onlineActivity: this.onlineActivityEligible
					? this.onlineActivity
					: false,
				differentAddress,
				duration: this.duration.id,
				selfParticipation: this.selfParticipation,
				furtherParticipants,
				potentialDates: this.potentialDates,
				onlineActivityExecution: this.onlineActivityEligible
					? this.onlineActivityExecution
					: false,
				counterProposalMaxTime: this.counterProposalMaxTime,
			};
		},
	},

	methods: {
		...mapActions('communication/appointment', {
			showAppointmentFan: 'show'
		}),
		reasonsChanged (v)
		{
			this.resetDurationIfNecessary();

			if (!v)
			{
				this.type = undefined;
			}
		},
		typeChanged ()
		{
			this.resetDurationIfNecessary();
		},
		resetDurationIfNecessary ()
		{
			const isInOptions = _.find(
				this.appointmentDurationCharacteristics,
				characteristic => characteristic.id === this.duration?.id
			);

			if (!isInOptions)
			{
				this.duration = undefined;
			}
		},
		openAppointments ()
		{
			this.showAppointmentFan({
				listType: LIST_TYPE__CUSTOMER
			});
		},
		furtherParticipantsChanged (checked)
		{
			this.furtherParticipantsList = [];

			if (!checked)
			{
				return;
			}

			this.addFurtherParticipant();
		},
		addFurtherParticipant ()
		{
			this.furtherParticipantsList.push({
				id: uuid.v4(),
				salutation: undefined,
				firstName: '',
				lastName: '',
				role: '',
				valid: false,
			});
		},
		removeFurtherParticipant (participant)
		{
			this.furtherParticipantsList = _.filter(
				this.furtherParticipantsList,
				p => p.id !== participant.id
			);

			if (this.furtherParticipantsList.length === 0)
			{
				this.furtherParticipants = false;
			}
		},
		changeFurtherParticipant (participant, data)
		{
			const index = _.findIndex(this.furtherParticipantsList, p => p.id === participant.id);

			if (index >= 0)
			{
				this.$set(this.furtherParticipantsList, index, {
					id: participant.id,
					...data
				});
			}
		},
		async sendRequest ()
		{
			this.sendingRequest = true;

			try
			{
				await new Reply()
					.setMessageId(this.message.id)
					.setAction(this.action)
					.setMakeAppointmentData(this.makeAppointmentData)
					.call();

				this.$emit('success');
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));

				error(e);
			}

			this.sendingRequest = false;
		}
	}
}
</script>
